import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Card,
  Table,
  Select,
  Input,
  Button,
  Tooltip,
  Modal,
  message,
  DatePicker,
} from "antd";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_usm_space_borrow,
  req_delete_usm_space,
  req_downloadfile_usm_space_borrow,
  req_list_usm_course_roomcode,
} from "../../api";
import SpaceUsetimesImportExcelModal from "./space-usetimes-import-excel-modal";
import SpaceBorrowModal from "./space-borrow-modal";

const { RangePicker } = DatePicker;

class SpaceBorrow extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    rooms: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    isShowDetailsModal: false,
    isUploadModal: false,

    startdate: "",
    enddate: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      startdate,
      enddate,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_usm_space_borrow(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      startdate,
      enddate,
      token
    );

    // console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_list_items = async (key) => {
    const { token } = this.props.user;
    this.setState({ rooms: [] });
    const result = await req_list_usm_course_roomcode(key, token);
    // console.log(result);
    if (result.total > 0) {
      const rooms = result.data;
      this.setState({ rooms, isShowCourseModal: true });
      //console.log(this.state);
    } else {
      const rooms = [];
      this.setState({ rooms });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      startdate,
      enddate,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_usm_space_borrow(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      startdate,
      enddate,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_usm_space(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "空間編號",
        dataIndex: "SpaceCode",
        width: 25,
        fixed: "left",
      },
      {
        title: "空間中文名稱",
        dataIndex: "SpaceStandardTwName",
        width: 40,
        fixed: "left",
      },
      {
        title: "保管單位",
        dataIndex: "ShortDepartmentTwName",
        width: 28,
      },
      {
        title: "保管人",
        dataIndex: "CustodianTwName",
        width: 25,
      },
      {
        title: "所在大樓",
        dataIndex: "BuildingName",
        width: 28,
      },
      {
        title: "至今累計(分鐘)",
        dataIndex: "ALLTotalTakeMinute",
        width: 25,
      },
      {
        title: "區間累計(分鐘)",
        dataIndex: "IntervalTakeMinute",
        width: 25,
      },
      {
        title: "",
        width: 20,
        fixed: "right",
        render: (item) => {
          return (
            <>
              <button
                className="btn btn-outline-dark btn-sm"
                style={{ width: "82px" }}
                onClick={() => this.handle_show_ui_modal("DETAILS", item)}
              >
                <i className="fa fa-bars"></i> 明細
              </button>
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_show_ui_modal = (type, item) => {
    //console.log(item);
    switch (type) {
      case "EXPORT":
        this.api_downloadfile_items();
        break;
      case "DETAILS":
        this.setState({
          isShowDetailsModal: true,
        });
        break;
      case "UPLOAD":
        this.setState({ isUploadModal: true });
        break;
      default:
    }
    this.setState({ item: item });
  };

  handle_date_change = (value, dateString) => {
    this.setState({ startdate: dateString[0], enddate: dateString[1] });
  };

  //////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      isUploadModal,
      isShowDetailsModal,
    } = this.state;
    const title = (
      <>
        <RangePicker format="YYYY-MM-DD" onChange={this.handle_date_change} />
        <Select
          value={searchField}
          style={{ width: 120 }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="BuildingName">所在大樓</Select.Option>
          <Select.Option value="SpaceCode">空間編號</Select.Option>
          <Select.Option value="SpaceStandardTwName">
            空間中文名稱
          </Select.Option>
          <Select.Option value="ShortDepartmentTwName">保管單位</Select.Option>
          <Select.Option value="CustodianTwName">保管人</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 100, margin: "0 5px" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <p></p>
      </>
    );
    const btn = (
      <>
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search" style={{ paddingRight: "4px" }}></i> 查詢
        </Button>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("UPLOAD", {})}
        >
          <i className="fas fa-users"></i>
          <span style={{ marginLeft: "4px" }}> 匯入</span>
        </Button>{" "}
        <Button
          type="primary"
          onClick={() => this.handle_show_ui_modal("EXPORT", {})}
        >
          <i className="fa fa-file-excel" style={{ paddingRight: "4px" }}></i>
          匯出
        </Button>
        <p></p>
      </>
    );

    return (
      <>
        {title}
        {btn}
        <Card>
          <Table
            bordered
            scroll={{ x: 800, y: 380 }}
            loading={loading}
            rowKey="Uid"
            columns={this.columns}
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
          />
          <Modal
            destroyOnClose={true}
            visible={isUploadModal}
            width={300}
            onOk={() => {
              this.setState({ isUploadModal: false });
              this.handle_data_refresh();
            }}
            onCancel={() => {
              this.setState({ isUploadModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SpaceUsetimesImportExcelModal />
          </Modal>

          <Modal
            destroyOnClose={true}
            visible={isShowDetailsModal}
            okText="關閉"
            onOk={() => {
              this.setState({ isShowDetailsModal: false });
            }}
            onCancel={() => {
              this.setState({ isShowDetailsModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <SpaceBorrowModal space={item} />
          </Modal>
        </Card>
      </>
    );
  }
}
export default connect((state) => ({ user: state.user }), {})(SpaceBorrow);
